import React from 'react';

interface ButtonProps {
  title: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  className?: string;
}

export const Button = ({
  title,
  onClick,
  variant = 'primary',
  disabled = false,
  className = ''
}: ButtonProps) => {
  const baseStyles = 'px-6 py-2 rounded-md transition-all duration-300 font-semibold relative overflow-hidden';

  const variantStyles = {
    primary: 'bg-gradient-to-r from-teamcare-cyan to-teamcare-cyan-dark border border-black border-2 text-white shadow-[2px_2px_0_0_rgba(0,0,0,100)] disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-[4px_4px_0_0_rgba(0,0,0,100)] hover:-translate-y-0.5 active:shadow-[1px_1px_0_0_rgba(0,0,0,100)] active:translate-y-0 bg-[length:200%_100%] hover:bg-[position:100%_0] animate-gradient-shift',
    secondary: 'border border-gray-300 text-gray-700 hover:bg-gray-50'
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {title}
    </button>
  );
};
